// src/pages/AdminLogin.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { auth } from "../firebase";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import {
  TextField,
  Button,
  Typography,
  Container,
  Card,
  CardContent,
} from "@mui/material";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);

  const goToAdmin = () => {
    // Persist a simple flag other components/guards can trust
    localStorage.setItem("isAdmin", "true");
    // React-router navigate first…
    navigate("/admin-dashboard", { replace: true });
    // …and hard redirect as a fallback to break any redirect loops
    setTimeout(() => {
      if (window.location.pathname !== "/admin-dashboard") {
        window.location.replace("/admin-dashboard");
      }
    }, 100);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      console.log("[admin] signing in…", email);
      const cred = await signInWithEmailAndPassword(auth, email, password);
      const user = cred.user;
      console.log("[admin] signed in, uid:", user.uid);

      // Optional: debug the token/claims (not required for this flow)
      try {
        const token = await user.getIdTokenResult(true);
        console.log("[admin] claims:", token.claims || {});
      } catch { /* noop */ }

      const db = getFirestore();
      const ref = doc(db, "users", user.uid);
      const snap = await getDoc(ref);
      console.log("[admin] firestore doc exists?", snap.exists());

      const role = snap.exists() ? snap.data()?.role : null;
      console.log("[admin] firestore role:", role);

      if (role === "admin") {
        // Mark admin & store uid for dashboard
        localStorage.setItem("adminId", user.uid);
        console.log("[admin] firestore says admin. navigating.");
        goToAdmin();
      } else {
        setError("Access denied. This page is for administrators only.");
        await signOut(auth);
      }
    } catch (err) {
      console.error("Admin login failed:", err);
      setError("Invalid credentials. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        backgroundImage: `url(${require("../assets/images/landing_background.jpg")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "100vh",
        fontFamily: "Montserrat, sans-serif",
      }}
    >
      <header className="page-header">
        <div className="logo">
          <img
            src={require("../assets/images/logo_name.PNG")}
            alt="YourStoryWorld Logo"
            style={{ height: "50px", cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
        </div>
      </header>

      <Container maxWidth="sm" style={{ marginTop: "40px" }}>
        <Card
          style={{
            padding: "30px",
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            borderRadius: "10px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
          }}
        >
          <CardContent>
            <Typography variant="h4" style={{ fontWeight: "bold", marginBottom: "20px" }}>
              Admin Sign In
            </Typography>
            {error && <Typography color="error" style={{ marginBottom: 8 }}>{error}</Typography>}

            <form onSubmit={handleLogin}>
              <TextField
                fullWidth
                label="Email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                margin="normal"
              />
              <TextField
                fullWidth
                label="Password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                margin="normal"
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                style={{ marginTop: "20px" }}
                disabled={loading}
              >
                {loading ? "Signing in..." : "Sign In as Admin"}
              </Button>
            </form>
          </CardContent>
        </Card>
      </Container>

      <footer className="page-footer" style={{ marginTop: "20px", textAlign: "center", padding: "15px 0" }}>
        <Typography>&copy; {new Date().getFullYear()} YourStoryWorld. All rights reserved.</Typography>
      </footer>
    </div>
  );
};

export default AdminLogin;
